module.exports = __webpack_public_path__ + "img/Secure key.3d803872.svg";